/* Add any global code here - Note that code included here will load/execute on EVERY page load - favour feature bundles where possible */
import "./main.scss";

import BreadcrumbNavigation from "shared/components/BreadcrumbElements/BreadcrumbNavigation.vue";
import { createApp } from "vue";

const breadcrumbMount = document.getElementById('breadcrumb');
if (breadcrumbMount) {
	const app = createApp({
		name: 'BreadcrumbApp',
	});
	app.component('breadcrumb-navigation', BreadcrumbNavigation);
	app.mount(breadcrumbMount);
}